import { Breadcrumbs } from 'app/domains/filesystem';
import { useFileBrowserContext } from './FileBrowserProvider';
export function FileBrowserBreadcrumbs() {
    const { breadcrumbs, onSelect } = useFileBrowserContext();
    return <Breadcrumbs breadcrumbs={breadcrumbs} onSelect={onSelect}/>;
}
